// extracted by mini-css-extract-plugin
export default {"privacyPolicy":"privacyPolicyPage_privacyPolicy__-xz+y","dataList":"privacyPolicyPage_dataList__EfRiu"};